module.exports = __webpack_public_path__ + "images/the-vibrator-43ff0856dff51d1df4fdeb80daebda21.png";